module.exports = __webpack_public_path__ + "web/img/verify4.9ece8bc4.png";